import { useCallback } from 'react';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { isNilOrEmpty } from 'ramda-extension';
import { useDispatch, useSelector } from 'react-redux';

import AvatarHead from 'components/atoms/CustomSVGIcon/AvatarHead';
import guarantorsEdit from 'features/views/guarantorsEdit';
import { getGuarantorsOfRegion } from 'features/views/guarantorsEdit/selectors';
import { joinString } from 'utils/string';

export const GuarantorsOfRegion = () => {
	const dispatch = useDispatch();
	const guarantorsOfRegion = useSelector(getGuarantorsOfRegion);

	const handleRemoveGuarantor = useCallback(
		(id) => () => {
			dispatch(guarantorsEdit.actions.removeAndReloadGuarantorOfRegion(id));
		},
		[dispatch],
	);

	return (
		<Stack
			direction="row"
			spacing={1}
			useFlexGap
			sx={{
				flexWrap: 'wrap',
			}}
		>
			{!isNilOrEmpty(guarantorsOfRegion) &&
				guarantorsOfRegion.map((guarantor) => {
					return (
						<Chip
							icon={<AvatarHead />}
							key={guarantor.id}
							label={joinString(' ', [guarantor.surname, guarantor.firstName])}
							size="small"
							onDelete={handleRemoveGuarantor(guarantor.id)}
						/>
					);
				})}
		</Stack>
	);
};

export default GuarantorsOfRegion;
